import {
  Grid,
  FormField,
  Input,
  Checkbox,
  Button
} from '@cloudscape-design/components';
import { IUser } from '../../models/interfaces';
import { useState } from 'react';

export const UserRow = (props: {
  user: IUser;
  forcePasswordReset: (arg1: string, arg2: string, arg3: boolean) => void;
  saveUser: (arg1: string, arg2: string, arg3: string, arg4: boolean) => void;
  updateUser: (ag1: string, arg2: string, arg3: boolean) => void;
}) => {
  const { user } = props;
  const [currentUserName, setCurrentUserName] = useState<string>(user.username);
  const [currentName, setCurrentName] = useState<string>(user.name);
  const [currentPassword, setCurrentPassword] = useState<string | null>(
    user.password
  );
  const [currentIsAdmin, setCurrentIsAdmin] = useState<boolean>(
    user.isAdmin ?? false
  );

  console.log('userrow uuser', user);
  return (
    <Grid
      gridDefinition={[
        { colspan: { default: 2, m: 2 } },
        { colspan: { default: 2, m: 2 } },
        { colspan: { default: 2, m: 2 } },
        { colspan: { default: 1, m: 1 } },
        { colspan: { default: 3, m: 3 } },
        { colspan: { default: 2, m: 2 } }
      ]}
    >
      <FormField stretch label="Username">
        <Input
          value={currentUserName}
          onChange={(event) => setCurrentUserName(event.detail.value)}
        />
      </FormField>
      <FormField stretch label="Name">
        <Input
          value={currentName}
          onChange={(event) => setCurrentName(event.detail.value)}
        />
      </FormField>
      <FormField stretch label="Password">
        <Input
          value={!currentPassword ? '' : currentPassword}
          type="password"
          onChange={(event) => setCurrentPassword(event.detail.value)}
        />
      </FormField>
      <FormField stretch label="Admin">
        <Checkbox
          onChange={({ detail }) => setCurrentIsAdmin(detail.checked)}
          checked={currentIsAdmin}
        >
          Admin
        </Checkbox>
      </FormField>
      <FormField label=" ">
      <Button
        onClick={() =>
          props.forcePasswordReset(
            user._id,
            currentPassword ?? '',
            currentIsAdmin
          )
        }
      >
        Reset Password
      </Button>

      </FormField>
      {!user._id ? (
        <Button
          onClick={() =>
            props.saveUser(
              currentUserName,
              currentName,
              currentPassword ?? '',
              currentIsAdmin
            )
          }
        >
          Save New User
        </Button>
      ) : (
        <Button
          onClick={() =>
            props.updateUser(
              currentUserName,
              currentName,
              currentIsAdmin
            )
          }
        >
          Save
        </Button>
      )}
    </Grid>
  );
};
